// @flow
import React from 'react';
import FeatureFlag from '../../features/components/FeatureFlag';
import { FEATURES } from '../../features/components/constants';

type Props = {
    settingsButton: React.ReactElement
};

export default function NotificationSettingsGuard({ settingsButton }: Props) {
    return (
        <FeatureFlag feature={FEATURES.WEB_NOTIFICATIONS}>
            {settingsButton}
        </FeatureFlag>
    );
}



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/components/NotificationSettingsGuard.jsx